import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Modal,
  Table,
  Tooltip,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';


import 'react-accessible-accordion/dist/fancy-example.css';
import Util from '../../../Common/util';
import API from '../../../Common/api';
import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
import DatePicker from "react-datepicker";
//import DropdownInput from "react-dropdown-input";

//import Select from "react-dropdown-select";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import $ from "jquery";
import readXlsxFile from "read-excel-file";
//import Util from "../../../Common/util";
import XLSX from "xlsx";
import Sheet from "../../../../images/BIN_MASTER_v1.xlsx";
import axios from "axios";
import { MDBDataTable } from "mdbreact";
//import API from "../../../Common/api";
import _ from "lodash";
import "./styles.css";
import LoadingOverlay from "react-loading-overlay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import exportToCSV from '../../../Common/exportcsv';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';



var url = window.location.hostname;
var port = window.location.port;
var data_img = [];
var assign_arr= [];
var unassign_arr = [];
var data_type = "";
var From_Date_val;
var to_Date_val;

const Heading = [['Sq. no','Missing Details', 'Brand' ,'Product Code', 'Product Desc' , 'Mrp',  'Batch', 'PKD', 'Receiving Config' , 'Qty' , 'Invoice Qty', 'Mapped Container ID']]

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.toggle = this.toggle.bind(this);
    this.SuccessConfirmtoggle = this.SuccessConfirmtoggle.bind(this);
    this.SuccessConfirmtoggle1 = this.SuccessConfirmtoggle1.bind(this);
    this.handleProdId = this.handleProdId.bind(this);
    this.SuccessConfirmoktoggle = this.SuccessConfirmoktoggle.bind(this);
    this.handleChangeASN = this.handleChangeASN.bind(this);
    this.handleChangeVan1 = this.handleChangeVan1.bind(this);
    this.changeEAN = this.changeEAN.bind(this);
    this.UnAssign = this.UnAssign.bind(this);
    this.assignedOrdersList = this.assignedOrdersList.bind(this);
    this.Assign = this.Assign.bind(this);
    this.OpenAssign = this.OpenAssign.bind(this);
    this.toggleOK = this.toggleOK.bind(this);
    this.toggleOKSuccess = this.toggleOKSuccess.bind(this);
    this.toggleOKNew = this.toggleOKNew.bind(this);
    this.toggleNew = this.toggleNew.bind(this);
    this.toggle1 = this.toggle1.bind(this);
    this.onGroupNameChange = this.onGroupNameChange.bind(this);
    this.toggleNPICancel = this.toggleNPICancel.bind(this);
    this.toggle2 = this.toggle2.bind(this);
    this.onConfirmProduct = this.onConfirmProduct.bind(this);
    this.ChangeLocation = this.ChangeLocation.bind(this);
    this.ChangeLocation = this.ChangeLocation.bind(this);
    this.ChangeOutlet = this.ChangeOutlet.bind(this);
    this.AssignData = this.AssignData.bind(this);
    this.AssignData1 = this.AssignData1.bind(this);
    this.ConfirmAssignData = this.ConfirmAssignData.bind(this);
    this.getInboundList = this.getInboundList.bind(this);
    this.addRow = this.addRow.bind(this);
    this.removeRow = this.removeRow.bind(this);
    this.checkedSingle2 = this.checkedSingle2.bind(this);
    this.Failedtoggle = this.Failedtoggle.bind(this);
    this.toggleTooltip = this.toggleTooltip.bind(this);

    this.state = {
      orderdata: [],
      variant_data: [],
      arr_data1: [],
      shelf_life_uom: [],
      ShowpopupLoader: false,
      showValidatedOption: false,
      SuccessMessageModal: false,
      totalTonnage: 0,
      totalWeightVal: 0,
      modalNew: false,
      createDisabled: false,
      tooltipOpen: false,
      showCreatedId: false,
      SuccessMessageModal1: false,
      showFilter: false,
      ShowConfirmLoader: false,
      po_type: "",
      asnLoader: false,
      inboundData: [],
      totalBillVal: 0,
      selectedVan1: "",
      reviewErr: "",
      selectedLocation1: "",
      showSelectGroup: false,
      showNewGroup: false,
      array_Data: [],
      unAssignOrder: [],
      van_list: [],
      assignOrder: [],
      isDisabledSearch: false,
      po_type: "",
      autoDesc: "",
      selectedDistributor: "",
      isChecked: false,
      showConfirmError: false,
      selectedVan: "",
      stationData: [],
      zoneData: [],
      reviewData: [],
      group_id: "",
      autoHsnCode: "",
      selectedOutlet: "",
      selectedDistributor: "",
      selectedLocation: "",
      selectedOrder: "",
      autoDesc: "",
      autoMargin: "",
      autoItemtype: "",
      article_id: "",
      mc_code_data: [],
      pack_size_uom: [],
      updated_fields: [],
      inboundDataList: [],
      file: {},
      FailedModal: false,
      invoice: "",
      prod_id_state : false,
      order: [],
      row_data: [],
      arr_data: [],
      task_type: [],
      pack_size1: [],
      loading2: false,
      variant1: [],
      task: [],
      edit_arr :[],
      store: [],
      distributor:[],
      areaCode:[],
      location: [],
      EditModal: false,
      selectedVanFilter: "",
      fromdate: "",
      todate: "",
      hsn_value: "",
      loader1: false,
      showVariant: false,
      isDisabledApply: false,
      mc_code: false,
      hsn_code: [],
      applyPackSize: "",
      mc_error: false,
      showTable: false,
      color_variant: false,
      disable_asn_button: true,
      assignLoader: false,
      assignDisabled: true,
      color_ean: false,
      color_product: false,
      product_name_val: "",
      applyMrp: "",
      status_type: "1",
      apply: true,
      store_id: "",
      task_id: "",
      polaris_id: "",
      task_type_value: "",
      request_id: "",
      taskId: "",
      packSize: "",
      constantmrp: "",
      showUnAssignedOrder: false,
      SuccessConfirmmodal1: false,
      longName: "",
      brand: "",
      mrp: "",
      ean: "",
      groupName: "",
      total_value: "",
      showFetchDispatchData: true,
      disabledBtn: false,
      showData: false,
      showErrorMessage: false,
      product_id: null,
      apply1: true,
      total_value: "",
      total_quantity: "",
      shelf_life_data: [],
      modal: false,
      selectedGroup: "",
      weight: "",
      volume: "",
      bill_number: "",
      bill_range: "",
      bill_value: "",
      pl_group: "",
      area_code: "",
      modal1: false,
      modal2: false,
      modalFailed: false,
      invoiceData: [],
      new_brand: "",
      failed_message: "",
      new_variant: "",
      showAllItem: false,
      disabledReasonBtn: true,
      showInvalidItem: false,
      showProceedbtn: false,
      showReasonbtn: false,
      reasonCodeNeeded: false,
      SuccessConfirmmodal: false,
      modalReason: false,
      loadingconfirmbtn: false,
      upc: 1,
      cpo: 1,
      loading: false,
      loading_overlay: false,
      url: window.location.hostname,
      port: window.location.port,
    };
  }

  Assign(){
      this.fetchDispatch();


  }

  onGroupNameChange(e){
    this.setState({
      groupName: e.target.value
    })
  }

   onClickMissingProduct = () =>{
    this.setState((prevState) => ({
      SuccessMessageModal1: !prevState.SuccessMessageModal1,
      
    }));
    // this.props.handleeClick(this.state.product_ids);
    window.location.href="/receiving/view_missing_product";  
  };


  toggleTooltip(){
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

   SuccessMessageToggle1 = () => {
    this.setState((prevState) => ({
      SuccessMessageModal1: !prevState.SuccessMessageModal1,
      
    }));

  };

   SuccessMessageToggle = () => {
    this.setState((prevState) => ({
      SuccessMessageModal: !prevState.SuccessMessageModal,
      
    }));
    
  };

  UnAssign(){
      this.setState({
       
        loading_overlay: true,

      })
      const payload = {
        location: this.state.selectedLocation,
  };

API.post('/product/product_master/v1/orders/', { param: payload })
      .then((response) => {

       this.setState({
         showUnAssignedOrder: false,
        showAssignedOrder: true,
        unAssignOrder: response.data.data.unassigned_orders,
        assignOrder: response.data.data.assigned_orders,
        loading_overlay: false,

       })
      })
      .catch(function(error) {});

  }



  assignedOrdersList(){

     const payload = {
      location: this.state.selectedLocation,
  };

API.post('/product/product_master/v1/orders/', { param: payload })
      .then((response) => {
       
       this.setState({
        unAssignOrder: response.data.data.unassigned_orders,
        assignOrder: response.data.data.assigned_orders

       })
      })
      .catch(function(error) {});

  }

  ChangeStation(evt, index) {
    const {reviewData} = this.state;
    var Station = evt.target.value
    reviewData[index]['station'] = Station

    this.setState({
      reviewData: reviewData
    })


  };

  ChangeZone(evt, index) {
    const {reviewData} = this.state;
    var Zone = evt.target.value
    reviewData[index]['zone'] = Zone

    this.setState({
      reviewData: reviewData
    })


  };

  changeBrand = (evt) => {
    this.setState({
      brand_value: evt.target.value,
      brand: evt.target.value,
    });
  };

  changeEAN = (evt) => {
    this.setState({
      ean: evt.target.value,
    });
  };









  AssignData(){
    this.setState({
      assignLoader: true,
      assignDisabled: true
    })
    var arrayData = this.state.arr_data.filter(
      (item) => item.isChecked === true
    );

     var arr = [];

    for (var i = 0; i < arrayData.length; i++) {
      arr.push(arrayData[i].id);
    }
    var req_id = [];

    const payload = {
     //location: this.state.selectedLocation,
          //type: "assign",
          van_id: this.state.selectedVan1,
          order_id: arr,
          group_id: this.state.selectedGroup
          //req_ids: req_id
  };

API.post('/master_ptl/van/v1/assign/', { param: payload })
      .then((response) => {
      
        this.setState({
          variant1: response.data.data,
          loading_overlay: true,
          success_message: response.data.message,
          //SuccessConfirmmodal: false
        });
        if(response.data.success == true){
          this.toggle();
        }else{
        this.Failedtoggle();
        }
        this.setState({
        SuccessConfirmmodal: false,
        showCreatedId: false,
        showSelectGroup: false,
        showNewGroup: false,
        assignLoader: false,
        assignDisabled: false,
        createDisabled: false
        })
        
        this.getBillList();
      })
      .catch(function(error) {});

  }
  ConfirmAssignData (){
    this.setState({
      disable_asn_button: true
    })
    var arrayData = this.state.arr_data1.filter(
      (item) => item.isChecked === true
    );
    var prod_arr = [];
    for (var i = 0; i < arrayData.length; i++) {
      prod_arr.push(arrayData[i].prod_id);

    }
    if (prod_arr.length >1){
      var filter_arr = ""
        for (var i = 0; i < arrayData.length; i++) {
         var filter_arr = prod_arr.filter((item) => item === arrayData[i].prod_id).length;
      if (filter_arr >= 2){
      
        this.setState({prod_id_state : true});
        
        break ;
      }
    };
    if(filter_arr === 1) {
      this.AssignData1()
    }
      
    }
    else { this.AssignData1()}
  }

  AssignData1(){
    

    var arrayData = this.state.arr_data1.filter(
      (item) => item.isChecked === true
    );

    this.setState({
      assignLoader1: true,
      assignDisabled1: true,
      asnLoader: true,
      po_type: arrayData[0].po_type
    })

     var purchase_order_ids = [];

    for (var i = 0; i < arrayData.length; i++) {
      var objData = {};
      
      objData['inbound_del_item_id'] = arrayData[i].id;
      objData['qty'] = arrayData[i].invoice_qty;
      purchase_order_ids.push(objData)

    }

    var req_id = [];

    var formData = new FormData();
    formData.append('location', this.state.selectedLocation);
    formData.append('inbound_del_item_data', JSON.stringify(purchase_order_ids));
    // Attach file
    formData.append('pdf_file', $('input[type=file]')[0].files[0]); 
    formData.append('inbound_del_no', this.state.inbound);
    formData.append('invoice_number', this.state.invoice);


    const payload = {
      formData
  };

  addAnalytics('Create ASN', 'Clicked Create ASN', formData);

API.post('/receiving/createASN/', { param: formData })
      .then((response) => {
        
        this.setState({
          variant1: response.data.data,
          loading_overlay: true,
          success_message: response.data.reason,
          failed_message: response.data.reason,
          totalBillVal: 0,
          totalTonnage: 0,
          totalWeightVal: 0,

          //SuccessConfirmmodal: false
        });
        if(response.data.status == true){
          this.toggle();
        }else{
        this.Failedtoggle();
        }
        this.setState({
        SuccessConfirmmodal1: false,
        disable_asn_button: false,
        showCreatedId: false,
        showSelectGroup: false,
        showNewGroup: false,
        assignLoader1: false,
        assignDisabled1: false,
        createDisabled: false,
        asnLoader: false
        })
        
        this.fetchDispatch();
      })
      .catch(function(error) {});

  }

  UnAssignData(){
    const payload = {
      location: this.state.selectedLocation,
      type: "unassign",
      group_id: this.state.selectedGroup,
      order_id: unassign_arr
  };

API.post('/product/product_master/v1/group/unassign/', { param: payload })
      .then((response) => {
      
        this.setState({
          variant1: response.data.data,
          loading_overlay: true,
        });
        
        this.fetchDispatch();
      })
      .catch(function(error) {});

  }


  checkAll1() {
    if (this.state.isChecked === false) {
      this.setState({
        isChecked: true,
        showSelectedBin: true,
      });

      //let newData = this.state.arr_data

      let newData = this.state.arr_data1.map((item) => ({
        ...item,
        isChecked: true,
      }));
       var arrayData = newData.filter(
      (item) => item.isChecked === true
    );

       var totalBill = 0;
     var totalWeight = 0;
     var totalValue = 0;


     for(var i = 0 ; i < arrayData.length; i++){
      var totalBill1 = arrayData[i].bill_count;
      var totalBillValue = totalBill + totalBill1;
      totalBill = totalBillValue;

      var totalWeight1 = arrayData[i].weight;
      var totalWeightValue = totalWeight + totalWeight1;
      totalWeight = totalWeightValue;

      var totalValue1 = arrayData[i].value;
      var totalValueTonnage = totalValue + totalValue1;
      totalValue = totalValueTonnage;
     }

      addAnalytics('Create ASN', 'Check All Order', newData);
  
   
     

      this.setState({
        tableRowsMap: this.assembleDispatchData(newData),
        arr_data1: newData,
         totalBillVal: totalBill,
      totalWeightVal: totalWeight.toFixed(2),
      totalTonnage: totalValue.toFixed(2),
        //SelectedBins: newBinData,
      });

    } else if (this.state.isChecked === true) {
      this.setState({
        isChecked: false,
        showSelectedBin: false,
      });

      let newData = this.state.arr_data1.map((item) => ({
        ...item,
        isChecked: false,
      }));

      this.setState({
        tableRowsMap: this.assembleDispatchData(newData),
        arr_data1: newData,
        totalBillVal: 0,
      totalWeightVal: 0,
      totalTonnage: 0
        //SelectedBins: newBinData,
      });

    }
  }


  checkAll() {
    if (this.state.isChecked === false) {
      this.setState({
        isChecked: true,
        showSelectedBin: true,
      });

      //let newData = this.state.arr_data

      let newData = this.state.arr_data.map((item) => ({
        ...item,
        isChecked: true,
      }));

      this.setState({
        tableRowsMap1: this.assembleDispatchData1(newData),
        arr_data: newData,
        //SelectedBins: newBinData,
      });

    } else if (this.state.isChecked === true) {
      this.setState({
        isChecked: false,
        showSelectedBin: false,
      });

      let newData = this.state.arr_data.map((item) => ({
        ...item,
        isChecked: false,
      }));

      this.setState({
        tableRowsMap1: this.assembleDispatchData1(newData),
        arr_data: newData,
        //SelectedBins: newBinData,
      });

    }
  }



  checkedSingle(index, ischecked,orderid) {
    
    var arr=[];
  
    this.setState({
      loading_overlay: true
    })
    let newData = this.state.arr_data;
    if (newData[index].isChecked === false) {
      newData[index].isChecked = true;
      data_type = "assign";
      assign_arr.push(orderid);
      
    } else if (newData[index].isChecked === true) {
      newData[index].isChecked = false;
      data_type = "unassign";
      unassign_arr.push(orderid);
      
    }

    this.setState({
      tableRowsMap1: this.assembleDispatchData1(newData),
      //binData: newData,
    });

    

    
  }


  checkedSingle1(index, ischecked,orderid) {
    
    var arr=[];
    addAnalytics('Create ASN', 'Single Check Selection', orderid);
    
    this.setState({
      loading_overlay: true
    })
    let newData = this.state.arr_data1;
    if (newData[index].isChecked === false) {
      newData[index].isChecked = true;
      data_type = "assign";
      assign_arr.push(orderid);
      
    } else if (newData[index].isChecked === true) {
      newData[index].isChecked = false;
      data_type = "unassign";
      unassign_arr.push(orderid);
      
    }

     
    this.setState({
      tableRowsMap: this.assembleDispatchData(newData),
      arr_data1: newData,
     
      //binData: newData,
    });

    
  }
  checkedSingle2(index, ischecked) {
    
    this.setState({
      loading_overlay: true,
      
    })
    let newData = this.state.array_Data;
  
    if (newData[index].isChecked === false) {
      newData[index].isChecked = true;
      this.state.edit_arr.push(index);  
    }
      
    else if (newData[index].isChecked === true) {
      newData[index].isChecked = false; 
      var ind = this.state.edit_arr.indexOf(index);
      this.state.edit_arr.splice(ind,1);   
    }

     this.setState({array_Data : newData});
     this.setState((prevState) => ({ loading2: !prevState.loading2 }));
     
    
  }


  changeEAN = (evt) => {
    this.setState({
      ean: evt.target.value,
    });
  };


  toggleOKNew() {
    this.setState((prevState) => ({ modalNew: !prevState.modalNew }));
    //this.fetchDispatch();
    // window.location.reload();
  }

  toggleOKSuccess(){
    var directPutawayFlag = Util.getCookie("direct_putaway_flag");
    var receivingAppFlag = Util.getCookie("receiving_app_flag");
     if(receivingAppFlag == 'false'){
      window.location = '/receiving/assign_user'
      //window.location.href = '/receiving/send_to_hht';
    }else if(receivingAppFlag == 'true'){
      if(directPutawayFlag == "true" && this.state.po_type == "SRN" || this.state.po_type == "PDR"){

       window.location.href = '/receiving/send_to_hht';
      } else if(directPutawayFlag == "false"){
         window.location.href = '/receiving/send_to_hht';
       }else{
         window.location = '/receiving/assign_user'
       }
    }
   
  }

  toggleNew() {
    this.setState((prevState) => ({ modalNew: !prevState.modalNew }));
  }

  toggleOK() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
    this.fetchDispatch();
  }

  toggle() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }
  Failedtoggle() {
    this.setState((prevState) => ({ Failedmodal: !prevState.Failedmodal }));
  }

  addRow(){
    this.setState((prevState) => ({ loading2: !prevState.loading2 }));
    let newData = this.state.array_Data;
    var obj = {};
    obj['id'] = this.state.id_value;
     obj['outer_qty'] = 0;
    obj['inner_qty'] = 0;
    obj['each_qty'] = 0;
    obj['batch'] = "";
    obj['PKD'] = "";
    obj['isChecked'] = false;

    newData.push(obj)
     addAnalytics('Create ASN', 'Add Row', newData);
    
    this.setState({
      //modal1: true,
      //loading2: false
      array_Data: newData,

    })

  }
  removeRow(){
    this.setState((prevState) => ({ loading2: !prevState.loading2 }));
    let newData = this.state.array_Data;
    let edit_index =this.state.edit_arr;

    let Dataa = []
    newData.map((item,index)=>{
      if (item.isChecked == false){
        Dataa.push(item);

      }}
    )

     addAnalytics('Create ASN', 'Remove Row', Dataa);

    this.setState({
      array_Data: Dataa,
      edit_arr : [],

    })

  }


  toggle1(evt, index, invoice, batch, pkd, id, cpo, upc) {
    this.setState((prevState) => ({ modal1: !prevState.modal1, array_Data: [] }));
     var arr = [];
    var obj = {};
    obj['id'] = id;
    obj['outer_qty'] = 0;
    obj['inner_qty'] = 0;
    obj['each_qty'] = 0;
    obj['batch'] = batch;
    obj['PKD'] = pkd;
    obj['isChecked'] = false;
    arr.push(obj);

    this.setState({
      array_Data: arr,
      auto_invoice: invoice,
      id_value: id,
      cpo: cpo,
      upc: upc
    })


  }

  toggleNPICancel() {
    this.setState((prevState) => ({
      modal1: !prevState.modal1,
      total_value :""
    }));
  }

  toggle2() {
    this.setState((prevState) => ({ modal2: !prevState.modal2 }));
   
    
   
  }

  toggleFailed() {
    this.setState((prevState) => ({ modalFailed: !prevState.modalFailed }));
  }




  SuccessConfirmtoggle() {
    this.setState((prevState) => ({
      SuccessConfirmmodal: !prevState.SuccessConfirmmodal,
    }));
    this.setState({
       // SuccessConfirmmodal: false,
        showCreatedId: false,
        showSelectGroup: false,
        showNewGroup: false,
        createDisabled: false
    })
  }


   SuccessConfirmtoggle1() {
    this.setState((prevState) => ({
      SuccessConfirmmodal1: !prevState.SuccessConfirmmodal1,
    }));
    this.setState({
       // SuccessConfirmmodal: false,
        showCreatedId: false,
        showSelectGroup: false,
        showNewGroup: false,
        createDisabled: false
    })
  }
  handleProdId() {
    this.setState((prevState) => ({
      prod_id_state : !prevState.prod_id_state,
    }));
  
  }

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41"+":8088";
    } else {
      url = window.location.hostname+port;
    }

     var today = new Date();
    
     From_Date_val = this.convertDate(today);
      to_Date_val = this.convertDate(today);

    var cookieUsername = Util.getCookie("token");
    var Location = Util.getCookie("selectedLocation");
    var username = Util.accessCookie("token");
    var invenOwner = Util.getCookie("invOwner");
    this.setState(
      {
        userName: cookieUsername,
        invenOwner: invenOwner,
        //fromdate:today,
        //todate:today,
        selectedLocation: Location,
      },
      () => {
        //this.fetchDispatch();
        this.getInboundList();
        
      }
    );

  }

  



  SuccessConfirmoktoggle() {
   var order_count = 0;
   var order_value = 0;
   var box_count = 0;
   var req_id = [];

   var area_code = [];
   for(var i = 0; i< this.state.arr_data.length; i++){
    if(this.state.arr_data[i].isChecked == true){
      order_count += this.state.arr_data[i].order_count;
      order_value += this.state.arr_data[i].order_value;
      box_count += this.state.arr_data[i].box_count;
      req_id = [...req_id, ...this.state.arr_data[i].req_ids];
      area_code.push(this.state.arr_data[i].area_code);


    }
   }

   var area_code_data = area_code.join(',')

    const payload = {
      location: this.state.selectedLocation,
      name: this.state.groupName,
      order_count: order_count,
      order_value: order_value,
      box_count: box_count,
      req_ids: req_id,
      area_code: area_code_data
  };

API.post('/sdr/vans/v1/create/', { param: payload })

      .then((response) => response.data)

      .then((data) => {

        this.setState({ selectedVan: data.data.van_id,showCreatedId: true, createDisabled: true, assignDisabled: false });
      })

      .then(async () => {
        
      });
   

    
  }



  onQuantityChangeBrand = (e) => {
    const value = e.target.value;
    this.setState({
      new_brand: value,
    });
  };

  onQuantityChangeShelf = (e) => {
    const value = e.target.value;
    this.setState({
      autoShelfLife: value,
      shelf_life: value,
    });
  };




  onInboundChange = (e) => {
    const value = e.target.value;
    var selectedInvoice = this.state.inboundData.filter((item) => e.target.value === item.inbound_delivery_number);

    console.log('selectedInvoice', selectedInvoice);
    this.setState({
      inbound: value,
      invoiceData: selectedInvoice[0].invoice_numbers
      
    });
  };

   onInvoiceChange = (e) => {
    const value = e.target.value;
    //console.log(e.target.value)
    this.setState({
      invoice: value,
      
    });
    if(this.state.file.name === undefined || this.state.file.name === null){
    this.setState({
      disable_asn_button: true
    });
    return false;
    }else{
       this.setState({
      disable_asn_button: false
    });
    }


  };
 
  onBillRangeChange = (e) => {
    const value = e.target.value;
    this.setState({
      bill_range: value,
      
    });
  };

   onBillValueeChange = (e) => {
    const value = e.target.value;
    this.setState({
      bill_value: value,
      
    });
  };

  onWeightChange = (e) => {
    const value = e.target.value;
    this.setState({
      weight: value,
      
    });
  };

  onVolumeChange = (e) => {
    const value = e.target.value;
    this.setState({
      volume: value,
      
    });
  };

  onVanFilterChange = (e) => {
    const value = e.target.value;
    this.setState({
      selectedVanFilter: value,
      
    });
  };



  changeProductName = (e) => {
    const value = e.target.value;
    this.setState({
      autoProductName: value,
      color_product: false,
    });
  };

  onQuantityChangePackSize = (e) => {
    const value = e.target.value;
    this.setState({
      autoPackSize: value,
      packSize: value,
      color_packSize: false,
    });
  };

  changeMrp = (e) => {
    const value = e.target.value;
    this.setState({
      mrp: value,
      color_mrp: false,
    });
  };

  changeMrp = (e) => {
    const value = e.target.value;
    this.setState({
      mrp: value,
      color_mrp: false,
    });
  };



  OpenAssign(){
  this.SuccessConfirmtoggle();
  }


  OpenAssign1(){
  this.SuccessConfirmtoggle1();
  }

 
  handleChangeASN(e, callback){
        const value = (e.target.value) ? e.target.value.replace(/[^0-9a-zA-Z]+/ig, "") : '';
       
          this.setState({
            selectedASN: value,
            assignDisabled: false
          })

          if (e.target.value !== value) {
              e.target.value = value;


          }

          
  };

   getInboundList() {
    
    const payload = {
      location: this.state.selectedLocation,
  };

API.post('/receiving/fetchInboundDeliveryList/', { param: payload })

    .then((response) => response.data)

    .then((data) => {
      console.log(data);
  
      this.setState({ inboundData: data });
    })

    .then(async () => {
      
    });
}

  editASN =() => {
    let newData = this.state.array_Data;
  
    const payload = {
      "id": newData[0].id,
      "edit_data": newData
  };
   addAnalytics('Create ASN', 'Confirm edited Data', payload);

    API.post('/receiving/editIDI/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        
        if (data.status == true){
          this.toggle1();
       this.toggleNew();
       this.fetchDispatch();
       this.setState({
        success_message : data.reason,
        total_value : ""
       })
        }
        if (data.status == false) {
          this.setState({
            failed_message : data.reason,
          
           })    

      this.Failedtoggle();
       this.fetchDispatch();}
      })
      .catch(function(error) {});

  }

  handleChangeVan1(e, callback){
        const value = (e.target.value) ? e.target.value.replace(/[^0-9a-zA-Z]+/ig, "") : '';
      
          this.setState({
            selectedVan1: value,
            assignDisabled: false
          })

          if (e.target.value !== value) {
              e.target.value = value;


          }

          
  };

  //handleChange(evt) {
  handleChange = (evt) => {
  const files = evt.target.files;
  var file1 = evt.target.value;
  this.setState({
    btnDisabled: true,
        loading_overlay: true,
  }, () => {
    
    if (files && files[0]) {
    this.setState({ 
    file: files[0] 
    })
  }else{
    this.setState({ 
    loading_overlay: false,
        btnDisabled: false,
        file:{},
    })
        $(".upload_success").css('display', 'none');
      $(".upload_error").css('display', 'none');
      $('.button_enable').removeAttr('disabled','disabled');
        return false;
  };
    
    var fileArray1 = file1.split(".");
    var extension1 = fileArray1[fileArray1.length - 1];

    if (document.getElementById("my_file_input") !== null) {
      document.getElementById("my_file_input").style.color = "";
      document.getElementById("my_file_input").style.width = "85%";
      document.getElementById("picking_label").style.display = "none";
    }else{
      document.getElementById("my_file_input").style.width = "26%";
    }

    if (extension1 != "pdf") {
      $(".upload_error").css("display", "block");
      $(".upload_success").css("display", "none");
    } else {
      $(".upload_success").css("display", "block");
      $(".upload_error").css("display", "none");
      $(".button_enable").removeAttr("disabled", "disabled");
      if(this.state.invoice == "" || this.state.invoice == undefined || this.state.invoice == null){
        this.setState({
        disable_asn_button: true
      })
      return false;
      }else{
        this.setState({
        disable_asn_button: false
      })
      }
      
    }
    
    this.setState({
      btnDisabled: false,
            loading_overlay: false,
    });
  });
  }

   validate = () => {
    console.log("invoiceData",this.state.invoiceData);


    if(this.state.po_type == "SRN" || this.state.po_type == "PDR"){
      this.setState({
        invoice: this.state.po_number_data
      })
    }else{
      this.setState({
        invoice: ""
      })
    }
    this.setState({
      loading_overlay: true,
    });
    const payload = {
      location: this.state.selectedLocation,

      inbound_delivery_no: this.state.inbound,
    };

     addAnalytics('Create ASN', 'Validate PO', payload);

    API.post("/receiving/validateASN/", { param: payload })
      .then((response) => {
        console.log(response);
        this.setState({
          respMsg: response.data.reason,
          loading_overlay: false,
        });
        
        if (response.data.status == true) {

          if(this.state.po_type == "PDR"){
            this.setState({
              disable_asn_button: false
            })
          }else if(this.state.po_type == "SRN"){
            this.setState({
              disable_asn_button: false
            })
          }else{
            this.setState({
              disable_asn_button: true
            })
          }
          
        
          this.setState({
            enableInitiate: false,
            showValidatedOption: true,
            enableValidate: true,
            //success_message: response.data.reason

          });
          this.SuccessMessageToggle();
          // this.setState((prevState) => ({ modal: !prevState.modal}));
        } else {
          localStorage.setItem("product_ids",JSON.stringify(response.data.product_ids));
      
          this.setState({
            enableInitiate: true,
            //respMsg: response.data.reason
          });
          // this.FailedConfirmtoggle();
          this.SuccessMessageToggle1();
        }

        //this.fetchDispatch();
      })
      .catch(function (error) {});
  };

  validateInput = (e) => {
  
    var k = e.keyCode || e.which;
    var ok = k >= 65 && k <= 90 || // A-Z
      k >= 96 && k <= 105 || // a-z
      k >= 35 && k <= 40 || // arrows
      k == 9 || //tab
      k == 46 || //del
      k == 8 || // backspaces
      (!e.shiftKey && k >= 48 && k <= 57); // only 0-9 (ignore SHIFT options)

    if(!ok || (e.ctrlKey && e.altKey)){
      e.preventDefault();
    }
  }

  ChangeLocation = (e) => {
    this.setState({
      selectedLocation1: e.target.value,
    });
  };

  ChangeOutlet = (e) => {
    this.setState({
      selectedOutlet: e.target.value,
    });
  };

  ChangeDistributor = (e) => {
      this.setState({
        selectedDistributor: e.target.value,
      });
  };

  ChangeOrder = (e) => {
      this.setState({
        selectedOrder: e.target.value,
      });
  };

  radioChangeGroup(data){
    if(data == "exsisting"){
      this.setState({
        showSelectGroup: true,
        showNewGroup: false,
        assignDisabled: true
      })
    }else if(data == "new"){
      this.setState({
        showSelectGroup: false,
        showNewGroup: true,
        assignDisabled: true
      })
    }
  }



  handleChange2 = (e) => {
    this.setState({
      task_id: e.target.value,
    });
  };
  handleChange3 = (e) => {
    this.setState({
      polaris_id: e.target.value,
    });
  };
  handleChange4 = (e) => {
    this.setState({
      task_type_value: e.target.value,
    });
  };

  handleChange5 = (e) => {
    this.setState({
      status_type: e.target.value,
    });
  };

  addCrate(evt, index, sorting_bin, lb_sku_id, total_qty, count, prod_config){
    
     let newData = this.state.arr_data1;
    var obj = {};
    obj['sorting_bin'] = sorting_bin;
    obj['lb_sku_id'] = lb_sku_id;
    obj['total_qty'] = total_qty;
    obj['crate'] = "";
    obj['crate_id'] = "";
    obj['count'] = count;
    obj['prod_config'] = prod_config;
    obj['new'] = true;
    obj['edit_val'] = 0

    newData.splice(index+1, 0, obj)
    this.setState({
      tableRowsMap: this.assembleDispatchData(newData),

    })

        


  }

  changeInvoiceQty = (evt,index,id) => {
    
    const {arr_data1} = this.state;
    var packed_qty = parseInt(evt.target.value);
    
    var objIndex = arr_data1.findIndex((obj => obj.prod_id == id));
    arr_data1[objIndex]['invoice_qty'] = packed_qty
    this.setState({
      arr_data1: arr_data1,
      tableRowsMap: this.assembleDispatchData(arr_data1),
    });
    
  };
  changeCount(e){
    this.setState({
      count: e.target.value
    })
  }

  changeCrateId(e, index, id, flag){
    this.setState({
      crateId: e.target.value
    })

    var arrayData= [];

    var obj = {};
    obj['receiving_hist_id'] = id;
    obj['total_qty'] = this.state.count;
    obj['crate'] = this.state.crateQty;
    obj['crate_id'] = this.state.crateId;
    obj['crate_flag'] = flag;

    arrayData.push(obj);




    const payload = {
      arrayData
  };

API.post('/receiving/updateCrate/', { param: payload })
    .then((response) => response.data)

    .then((data) => {
      
    })

    .then(async () => {
      
    });

  }

  changeInvoice(evt){
    this.setState({})
  }

  assembleDispatchData = (dispatchData) => {

    let DispatchData = dispatchData.map((post, index) => {
     

      return {
       
        
        action: <input style={{textAlign: 'center'}} type="checkbox" value={post.isChecked} checked={post.isChecked} onChange={() => this.checkedSingle1(index,post.isChecked, post.id)}/>,
        sequence_no:  post.stock_type == 1 ?  <span> <span style={{color: 'red', fontSize: 11}}> Damage </span> <br/> <span> {post.po_line_no} </span> </span> : post.stock_type == 2 ? <span> <span style={{color: 'red', fontSize: 11}}> Expired </span> <br/> <span> {post.po_line_no} </span> </span> : <span>  {post.po_line_no}  </span> ,
        missing_details: post.ean == "" && post.lbh == "" ? <span style ={{color: 'red'}}> EAN, LBH </span> : post.ean == "" ? <span style ={{color: 'red'}}> EAN </span> : post.lbh == "" ? <span style ={{color: 'red'}}> LBH </span> : <span> </span>, 
        brand: post.brand,
        prod_code: post.SKU7_code,
        product_desc: post.product__lb_sku_product_name,
        mrp: post.mrp,
        batch: post.batch, 
        pkd: post.pkd,
        receiving_config: post.receiving_config,
        qty: post.qty,
        invoice_qty: post.po_type === "PO" || post.po_type === "STN" ? <span><input disabled Value={post.invoice_qty}  style={{fontSize: 12, height: 31, width: 80}} type = "text"  className="form-control" placeholder="Invoice Qty" onChange={(evt) => this.changeInvoiceQty(evt,index, post.prod_id)}  /><a style={{color: '#70bbfc', fontWeight: 'bold'}} onClick={(evt) => this.toggle1(evt,index, post.invoice_qty, post.batch, post.pkd, post.id, post.cpo, post.upc)}>Edit</a></span> : <span><input disabled Value={post.invoice_qty}  style={{fontSize: 12, height: 31, width: 80}} type = "text"  className="form-control" placeholder="Invoice Qty"  onChange={(evt) => this.changeInvoiceQty(evt,index, post.prod_id)}  /></span>,  
        mapped_container_id: post.crate
        
      };
    });

    this.setState({
      po_type: dispatchData[0].po_type,
      loading_overlay: false,
      loading: false,
    });

    return DispatchData;
  };

  PKDChange = (evt,id, index) => {
    
    const {array_Data} = this.state;
    var packed_qty = evt.target.value;
    
    var objIndex = array_Data.findIndex(((obj, index1) => index1 == index));
    array_Data[objIndex]['PKD'] = packed_qty
   
    this.setState({
      array_Data: array_Data,
      //tableRowsMap: this.assembleDispatchData(arr_data1),
    });
    
  };

  BatchChange = (evt,id, index) => {
    
    const {array_Data} = this.state;
    var packed_qty = evt.target.value;
    
    var objIndex = array_Data.findIndex((obj,index1) => index1 == index);
    array_Data[objIndex]['batch'] = packed_qty
  
    this.setState({
      array_Data: array_Data,
      //tableRowsMap: this.assembleDispatchData(arr_data1),
    });
    
  };

  OuterChange = (evt,id, index) => {
    
    const {array_Data} = this.state;
    var packed_qty = Number(evt.target.value);
   
     var objIndex = array_Data.findIndex((obj, index1) => index1 == index);
    array_Data[objIndex]['outer_qty'] = packed_qty

     var total_inner= 0;
    var total_outer = 0;
    var total_each = 0;
    var total_value = 0;
    for(var i = 0; i< array_Data.length; i++){

      total_inner += parseInt(array_Data[i].inner_qty);
      total_outer += parseInt(array_Data[i].outer_qty);
      total_each += parseInt(array_Data[i].each_qty);

    }

    total_value = ((total_outer * parseInt(this.state.cpo) * parseInt(this.state.upc)) + (total_inner * parseInt(this.state.upc)) + (total_each));

    this.setState({
      array_Data: array_Data,
      total_value: total_value
      //tableRowsMap: this.assembleDispatchData(arr_data1),
    });
    
  };

  InnerChange = (evt,id,index) => {
    
    const {array_Data} = this.state;
    var packed_qty = Number(evt.target.value);
   
     var objIndex = array_Data.findIndex((obj, index1) => index1 == index);
    array_Data[objIndex]['inner_qty'] = packed_qty
  
     var total_inner= 0;
    var total_outer = 0;
    var total_each = 0;
    var total_value = 0;
    for(var i = 0; i< array_Data.length; i++){

      total_inner += parseInt(array_Data[i].inner_qty);
      total_outer += parseInt(array_Data[i].outer_qty);
      total_each += parseInt(array_Data[i].each_qty);

    }

    total_value = (total_outer * parseInt(this.state.cpo) * parseInt(this.state.upc)) + (total_inner * parseInt(this.state.upc)) + (total_each);

    this.setState({
      array_Data: array_Data,
      total_value: total_value
      //tableRowsMap: this.assembleDispatchData(arr_data1),
    });
    
  };

  EachChange = (evt,id, index) => {
    
    const {array_Data} = this.state;
   
    var packed_qty = Number(evt.target.value);
    
     var objIndex = array_Data.findIndex((obj, index1) => index1 == index);
    array_Data[objIndex]['each_qty'] = packed_qty
    
     var total_inner= 0;
    var total_outer = 0;
    var total_each = 0;
    var total_value = 0;
    for(var i = 0; i< array_Data.length; i++){

      total_inner += parseInt(array_Data[i].inner_qty);
      total_outer += parseInt(array_Data[i].outer_qty);
      total_each += parseInt(array_Data[i].each_qty);

    }

    total_value = (total_outer * parseInt(this.state.cpo) * parseInt(this.state.upc)) + (total_inner * parseInt(this.state.upc)) + (total_each);

    this.setState({
      array_Data: array_Data,
      total_value: total_value
      //tableRowsMap: this.assembleDispatchData(arr_data1),
    });
    
  };



  assembleDispatchData1 = (dispatchData) => {
  
    let DispatchData1 = dispatchData.map((post, index) => {
     
       return {
       action: <input style={{textAlign: 'center'}} type="checkbox" value={post.isChecked} checked={post.isChecked} onChange={() => this.checkedSingle(index,post.isChecked, post.id)}/>,
        
        
//area_code: <span style={{color:'#70bbfc', cursor: 'pointer'}} onClick={() => this.getBillList(index,post.area_code)}>{post.area_code}</span>,
        rec_bin: post.sorting_bin__bin_address,
        //product_id: post.product__lb_sku_id,
        product_desc: post.product__lb_sku_product_name,
        batch: post.receiving_request__batch,
        pkd: post.pkd,
        mrp: post.product__mrp,
        total_qty: <input value={post.received_qty}  style={{fontSize: 12, height: 31, width: 120}} type = "text"  className="form-control" placeholder="Enter Packed Qty" onChange={(evt) => this.changePackedQty(evt,index, post.id)}  />,   
        status: <span> <select
                    className="form-control"
                    disabled= {post.child_product == true ? true : false}
                    defaultValue={post.reason}
                    style={{ fontSize: 13,  width: 120 }}
                    onChange={(evt) => this.changeReason(evt,index,post.id)}
                  >
                    <option value="">Select Reason</option>
                    {
                      this.state.reasonData.length > 0 &&
                      this.state.reasonData.map((reasonData) => {
                        return (
                          <option value={reasonData.id}> {reasonData.name}</option>
                        );
                      })}
                  </select> <br/> {post.isChecked == "true" && <span className={"err_reason_"+post.id} style={{fontSize: 12, color: 'red'}}> Please Select Reason</span>}</span>, 
       


        
      };


     
    });

    this.setState({
      loading_overlay: false,
      loading: false,
    });

    return DispatchData1;
  };


  onConfirmProduct() {
    this.setState({
      disable_submit_button: true,
      ShowEditLoader: true

    })
    var arr = [];
    for(var i = 0; i< this.state.reviewData.length; i++ ){
      var obj= {}
      obj['van_id'] = this.state.reviewData[i].van_id;
      obj['zone'] = this.state.reviewData[i].zone;


      arr.push(obj);
    }
    
    const payload = {
      data_list: arr,
      ptl_type: "manual_ptl",
      customer: this.state.invenOwner
  };

API.post('/packing/van/v1/confirm/pick/pack/planning/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          //success_message: data.message,
          failed_message: data.message,
          disable_submit_button: false,
          ShowEditLoader: false,
          totalBillVal: 0,
          totalTonnage: 0,
          totalWeightVal: 0,
        });

        if(data.success == true){
         var objData =  Object.keys(data.data).map(function(k){return data.data[k]}).join(",");
         var objKey = Object.keys(data.data).map(function(k){return k}).join(",");
    
          this.setState({
          success_message: "Sub-Group-Id " + " " + objData + "is created for Van" + " " +  objKey,
          
        });
          this.toggle2();
          this.toggleNew();
        }else{
          //this.toggle2();
          this.toggleFailed();
        }
        

        this.fetchDispatch();
      })
      .catch(function(error) {});
  }

  


  SearchData(){
  
    this.setState({
    loading_overlay: true
    })
    var newArrData = [];
   
     newArrData = this.state.arr_data.filter(
      (item) => item.party_code == this.state.selectedOutlet || item.distributor_code == this.state.selectedDistributor || item.delivery_center == this.state.selectedLocation || item.outlet_order_no == this.state.selectedOrder
    );

    this.setState({
    arr_data: newArrData,
    tableRowsMap: this.assembleDispatchData(newArrData),
    })
  }

  formatDate = (date) => {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [day, month, year].join('-');
}

 
  convertDate = (inputFormat) => {
  function pad(s) { return (s < 10) ? '0' + s : s; }
  var d = new Date(inputFormat)
  return [d.getFullYear(), pad(d.getMonth()+1), pad(d.getDate())].join('-')
}

  FromDateChange = date  => {
      this.setState({
        fromdate :  date
      }) 
      if(date != null){
      From_Date_val = this.convertDate(date);
      } else{
        From_Date_val= ""
      }
      
      
  }

  ToDateChange = date => {
      const d = new Date(date);
      this.setState({
        todate :  date
      }) 
      
       if(date != null){
      to_Date_val = this.convertDate(date); 
      } else{
        to_Date_val= ""
      }
  }

  getZone =()=> {

     const payload = {
      "station_type":"PTL",
  };

API.post('/product/product_master/v1/station/dropdown/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
       
       this.setState({
       zoneData: data.data
       })
      })
      .catch(function(error) {});
      
      
  }


   getStation =()=> {

     const payload = {
      location: this.state.selectedLocation,
        
  };

API.post('/product/product_master/v1/station/type/dropdown/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
      
       this.setState({
        stationData: data.data
       })
      })
      .catch(function(error) {});
      
      
  }







  fetchDispatch = (order_no) => {
    var arr_data = [];
    var total_val = 0;
    var total_qty = 0;
    this.setState({
      //loading_overlay: true,
      loading: true,
      showValidatedOption: false,
      enableValidate: false,
      isChecked: false
    });

    var batch = localStorage.getItem('batch_id');

    const payload = {
      location: this.state.selectedLocation1,
      idl_number: this.state.inbound,
  };
  addAnalytics('Create ASN', 'Search Inbound Del', payload);

API.post('/receiving/fetchInboundDeliveryItem/', { param: payload })
      .then((response) => response.data)
      .then((data) => {

        console.log(data);

         if(data.success == false){
            this.setState({
              failed_message: data.message,
              loading: false

            })
            this.Failedtoggle();
            return false;
        }else{



        this.setState({
          showFetchDispatchData: true,
          po_number_data: data.data[0].po_number,
        });

        
        var AssignData = data.data.map((item) => ({
          ...item,
          isChecked: false,
          edit_val: 2,
          invoice_qty: item.qty,
        }));

        var inboundDataList = [];

        for(var i = 0; i< AssignData.length; i++){

          var obj = {};

          obj['Seq no.'] = AssignData[i].po_line_no;

           if(AssignData[i].ean == "" && AssignData[i].lbh == ""){
            obj['Missing Details'] = "EAN,LBH";
          }else
          if(AssignData[i].ean == ""){
            obj['Missing Details'] = "EAN";
          }else
          if(AssignData[i].lbh == ""){
            obj['Missing Details'] = "LBH";
          }else{
            obj['Missing Details'] = "";
          }
          obj['Brand'] = AssignData[i].brand;
          obj['Product Code'] = AssignData[i].prod_code;
          obj['Product Desc'] = AssignData[i].product__lb_sku_product_name;
          obj['MRP'] = AssignData[i].mrp;
          obj['Batch'] = AssignData[i].batch;
          obj['PKD'] = AssignData[i].pkd;
          obj['Receiving Config'] = AssignData[i].receiving_config;
          obj['Qty'] = AssignData[i].qty;
          obj['Invoice Qty'] = AssignData[i].invoice_qty;
          obj['Mapped Container Id'] = AssignData[i].crate;

          inboundDataList.push(obj);


        }
     

        this.setState({
         
          arr_data1: AssignData,
          tableRowsMap: this.assembleDispatchData(AssignData),
          inboundDataList: inboundDataList,
          //tableRowsMap1: this.assembleDispatchData1(data),
          showFetchDispatchData: true,
          dispatch_status: false,
        });
      }
      })
      .catch(function(error) {});
  };

  toggleField = (hideObj,showObj) =>{
     hideObj.disabled=true;   
     hideObj.style.display='none';
     showObj.disabled=false;  
     showObj.style.display='inline';
     showObj.focus();
}


   getBillList(index, area_code){
    var arr_data = [];
    var total_val = 0;
    var total_qty = 0;
    this.setState({
      //loading_overlay: true,
      loading: true,
    });

    var batch = localStorage.getItem('batch_id');

    const payload = {
     //location: this.state.selectedLocation1,
          //"data_type": "unassigned",
          group_id: this.state.selectedGroup,
          pl_group: this.state.pl_group,
          area_code: area_code,
          bill_range: this.state.bill_range,
          bill_value: this.state.bill_value,
          weight: this.state.weight,
          volume: this.state.volume,
          //outlet: this.state.selectedOutlet,
          //location: this.state.selectedLocation,
          from_data: From_Date_val,
          to_date: to_Date_val
  };

API.post('/master_ptl/view/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {

        this.setState({
          showFetchDispatchData1: true,
        });

        var arr = data.data;

        const sortNullishValues = (arr = []) => {
         const assignValue = val => {
            if(val == ""){
               
                return val;
            }
            else{
              return Infinity;
            };
         };
         const sorter = (a, b)=> {
            return assignValue(a.van_master) - assignValue(b.van_master);
         };
         arr.sort(sorter);
      }
      sortNullishValues(arr);

        let UnAssignData = arr.map((item) => ({
          ...item,
          isChecked: false,
        }));

        

        this.setState({
          orderData: data.data,
          total_value: data.data.total_value,
          total_quantity: data.data.total_qty,
          arr_data: UnAssignData,
          tableRowsMap1: this.assembleDispatchData1(UnAssignData),
          showFetchDispatchData1: true,
          dispatch_status: false,
        });
        this.toggle1();
      })
      .catch(function(error) {});
  };



  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { modal, modal1, modal2, modalNew ,prod_id_state, SuccessMessageModal1, SuccessMessageModal} = this.state;
    const { modalFailed, modalReason } = this.state;
    const { SuccessConfirmmodal, Failedmodal,SuccessConfirmmodal1 ,array_Data} = this.state;
    const { EditModal } = this.state;

    const dispatchData = {
      columns: [
        {
          label: <input type='checkbox' checked={this.state.isChecked} onChange={() => this.checkAll1()} />,

          field: "action",
          width: 50,
        },
        
        {
          label : "Seq No.",
          field : "sequence_no",
          width : 100,
        },

        {
          label : "Missing Details",
          field : "missing_details",
          width : 130,
        },

        {
          label: "Brand",

          field: "brand",
          width: 130,
        },
        
       
        {
          label: "Prod Code",

          field: "prod_code",
          width: 160,
        },
        {
          label: "Prod Desc",

          field: "product_desc",
          width: 130,
        },
        {
          label: "Mrp",

          field: "mrp",
          width: 100,
        },


        {
          label: "Batch",

          field: "batch",
          width: 120,
        },

        {
          label: "PKD",

          field: "pkd",
          width: 100,
        },

        {
          label: "Receiving Config",

          field: "receiving_config",
          width: 150,
        },

        {
          label: "QTY",

          field: "qty",
          width: 100,
        },

        {
          label: "Invoice Qty",

          field: "invoice_qty",
          width: 130,
        },

         {
          label: "Mapped Container Id",

          field: "mapped_container_id",
          width: 160,
        },


      ],



      rows: this.state.tableRowsMap,
    };


    const dispatchData1 = {
      columns: [
        {
          label: <input type='checkbox' checked={this.state.isChecked} onChange={() => this.checkAll1()} />,

          field: "action",
          width: 50,
        },
        
        {
          label: "Location",

          field: "rec_bin",
          width: 120,
        },
        
        {
          label: "Prod Desc",

          field: "product_desc",
          width: 130,
        },

         {
          label: "MRP",

          field: "mrp",
          width: 90,
        },


        {
          label: "Batch",

          field: "batch",
          width: 90,
        },


        {
          label: "PKD",

          field: "pkd",
          width: 90,
        },

        {
          label: "Receiving Config",

          field: "receiving_config",
          width: 120,
        },

         {
          label: "Invoice Qty",

          field: "invoice_qty",
          width: 110,
        },
       
        {
          label: "Total Qty Actual/Expected",

          field: "total_qty",
          width: 180,
        },
        
        {
          label: "Status",

          field: "status",
          width: 100,
        },
        {
          label: "Reason",

          field: "reason",
          width: 100,
        },

        

      ],

      rows: this.state.tableRowsMap1,
    };

    return (
      <Col xl={12}>
        
        {this.state.loading_overlay && (
          <LoadingOverlay active={true} spinner text="wertyui" />
        )}
        <Card>
          <CardBody style={{ paddingTop: 10, height: 60, paddingBottom: 12 }}>
           

            <form className="form form--inline" onSubmit={handleSubmit}>
             
               <div
                className="form__form-group col-xl-3"
                style={{ marginBottom: "0px",}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                   <select
                    className="form-control"
                    style={{ fontSize: 13, }}
                    onChange={this.onInboundChange}
                  >
                    <option value="">Select Inbound Del No.</option>
                    {
                      this.state.inboundData.length > 0 &&
                      this.state.inboundData.map((inboundData) => {
                        return (
                          <option value={inboundData.inbound_delivery_number}> {inboundData.inbound_delivery_number}</option>
                        );
                      })}
                  </select>

                   {/*<input type = "text" className="form-control group_text1" placeholder= "Inbound Delivery Number" onChange={this.onInboundChange}/>*/}
                </div>
              </div>

               <div
                className="form__form-group col-xl-2"
                style={{ marginBottom: "0px", marginLeft: 15, display: 'none'}}
              >
              <div
                  className="form__form-group-field"
                  
                >
                
          <DatePicker
                    selected={this.state.fromdate}
                    onChange={this.FromDateChange}
                    className="ledger_fromdate"
          placeholderText="Start Date"
                    format='yyyy-MM-dd'
                  />
                  {this.state.showFromErr &&
                  <span style={{color: 'red', fontSize: 11}}>Please Select From Date</span>
                  }
                  </div>
              </div>
        <div  style={{width:'15%',marginBottom:'0px', float: 'left', marginRight: 5, display: 'none'}}>
        <DatePicker 
                   selected={this.state.todate}
                    onChange={this.ToDateChange}
                    className="ledger_todate"
          placeholderText="End Date"
                />
                {this.state.showToErr &&
                  <span style={{color: 'red', fontSize: 11}}>Please Select To Date</span>
                  }
              </div>



              
             

                <div
                className="form__form-group col-xl-2"
                style={{ display: "none", marginBottom: "0px",  marginTop: 10 }}
              >
                <div
                  className="form__form-group-field"
                  style={{ display: "contents" }}
                >
                   <input type = "text" className="form-control group_text1" placeholder= "Enter Van " onChange={this.onVanFilterChange}/>
                </div>
              </div>

              <div
                className="form__form-group col-xl-2"
                style={{ marginBottom: "0px", marginRight: 12, marginTop: 10, display: 'none' }}
              >
                <div
                  className="form__form-group-field"
                   
                >
                    <select
                    className="form-control"
                    value={this.state.store_id}
                    style={{ fontSize: 13 }}
                    onChange={this.onBillRangeChange}
                  >
                    <option value="">Select Bill Range</option>
                   
                    <option value="greater"> {'<'}</option>
                    <option value="equal"> {'='} </option>
                    <option value="less"> {'>'}</option>
            
                  </select>
                   {/*<input type = "text" className="form-control group_text1" placeholder= "Enter Bill Range" onChange={this.onBillRangeChange}/> */}
                </div>
              </div>

              <div
                className="form__form-group col-xl-2"
                style={{ display: "none", marginBottom: "0px", marginRight: 12 , marginTop: 10 }}
              >
                <div
                  className="form__form-group-field"
                  style={{ display: "contents" }}
                >
                   <input type = "text" className="form-control group_text1" placeholder= "Enter Bill Value" onChange={this.onBillValueeChange}/>
                </div>
              </div>

              <div
                className="form__form-group col-xl-2"
                style={{ display: "none", marginBottom: "0px", marginRight: 6, marginTop: 10 }}
              >
                <div
                  className="form__form-group-field"
                  style={{ display: "contents" }}
                >
                   <input type = "text" className="form-control group_text1" placeholder= "Enter Weight" onChange={this.onWeightChange}/>
                </div>
              </div>
             

              <div className="form__form-group col-xl-2">
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_enable"
                    onClick={() => this.fetchDispatch()}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Search
                  </Button>
                </ButtonToolbar>
              </div>
             
            </form>
          </CardBody>

          {this.state.showFetchDispatchData && (
            <div>
            <CardBody style={{ marginTop: 10, paddingTop: 0, paddingBottom: 0 }}>


              
             <div
                className="dispatchData stock_check_data style_table"
                style={{ marginTop: 1 }}
              >

              <div style={{width: '100%', float: 'left', marginTop: 12}}>
               <button
                  style={{
                    marginBottom: 4,
                    marginTop: 10,
                    paddingTop: 5,
                    paddingBottom: 5,
                    paddingLeft: 26,
                    paddingRight: 26,
                    width: '12%',
                    float: 'left'
                  }}
                  variant="warning"
                  disabled={this.state.enableValidate}
                  onClick={(e) => this.validate()}
                  className="btn-secondary-success"
                >
                  {" "}
                  {this.state.createLoader && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  Validate
                </button>
                <div style={{width: '85%', float: 'left'}}>
                 <span
                    className="pull-right"
                    onClick={() => exportToCSV(this.state.inboundDataList, "ASNData", Heading)}
                    style={{
                      fontSize: "17px",
                      paddingRight: "0px",
                      cursor: "pointer",
                      color: "#919193",
                      paddingTop: "9px",
                      textAlign: 'right'
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                  </span>
                  </div>


        
  

                    <div style={{width: '100%', float: 'left', marginTop: 2}}>
                     {this.state.showValidatedOption &&
                <input style={{width: '18%', float:'left', height: 45}} disabled = {this.state.po_type == "SRN" ? true : this.state.po_type == "PDR" ? true : false} maxlength="16" type = "text" className="form-control invoice_input" placeholder= "Invoice Number" value={this.state.invoice} onChange={this.onInvoiceChange}/>
                   }

               {/* {this.state.showValidatedOption &&
                <div>
                  <input onChange={this.onInvoiceChange} className="form-control invoice_input" maxlength="16" disabled = {this.state.po_type == "SRN" ? true : this.state.po_type == "PDR" ? true : false} style={{width: '18%', float:'left', height: 45}} placeholder= "Invoice Number" list="browsers" name="browser" id="browser"/>
                    <datalist id="browsers">

                      {
                      this.state.invoiceData.map((invoice_no) => {
                        return (
                          <option value={invoice_no}/>
                        );
                      })}

  
                    </datalist> 
                </div>
                   }*/}
                    {this.state.showValidatedOption &&
                   <div
                className="form__form-group col-xl-4"
                style={{ marginBottom: "0px", width: '40%', float: 'left' , marginLeft: 12}}
              >
                <div className="row">
                  <div
                    className="col-xl-12"
                    style={{ border: "1px solid #f2f4f7", marginTop: 4 }}
                  >
                    <input
                      style={{
                        paddingTop: 3,
                        height: 30,
                        color: "transparent",
                        width: "34%",
                        border: "0px",
                      }}
                      disabled = {this.state.po_type == "SRN" ? true : this.state.po_type == "PDR" ? true : false}
                      name="defaultInput"
                      component="input"
                      type="file"
                      placeholder="Default Input"
                     
                      id="my_file_input"
                      onChange={this.handleChange}
            ref={ref=> this.fileInput = ref}
                    />
                    <label for="files" id="picking_label">
                      Select File
                    </label>
                  </div>
                  <div className="col-xl-12">
                    <span
                      style={{ display: "none", color: "red" }}
                      className="upload_error"
                    >
                      {" "}
                      Invalid file format. Please select .pdf file
                      format{" "}
                    </span>
                    <span
                      style={{ display: "none", color: "green", marginTop: 8 }}
                      className="upload_success"
                    >
                      {" "}
                      Valid file format{" "}
                    </span>
                  </div>
                </div>
                </div>
              }

               {this.state.showValidatedOption &&

                <Button disabled={this.state.disable_asn_button} style={{marginBottom: 20, marginTop:2, marginLeft: 12, paddingTop: 8, paddingBottom:8, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => this.ConfirmAssignData()}>{this.state.asnLoader && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}Create ASN</Button>}</div>
                    </div>
                    <div style={{marginBottom: 8}}>
                    <span style={{paddingBottom: 8}}><strong>PO Number: {this.state.po_number_data}</strong></span>
                    </div>
                <MDBDataTable
                  scrollX
                  scrollY
                  maxHeight="700px"
                  searching={false}
                  displayEntries={false}
                   paging= {false}
                  striped
                  bordered
                  data={dispatchData}
                />


              </div>

                      
            </CardBody>

            </div>
          )}
        </Card>

         <Modal isOpen={modalNew} backdrop="static" toggle={this.toggleNew}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggleNew}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h6>{this.state.success_message} </h6>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggleOKNew}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={modal} backdrop="static" toggle={this.toggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h6>{this.state.success_message} </h6>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggleOKSuccess}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={SuccessMessageModal} toggle={this.SuccessMessageToggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.SuccessMessageToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4>{this.state.respMsg} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.SuccessMessageToggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={modalFailed} backdrop="static" toggle={this.toggleFailed}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4>{this.state.failed_message} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggleOK}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

          <Modal isOpen={Failedmodal} backdrop="static" toggle={this.Failedtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
            <h4>{this.state.failed_message} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.Failedtoggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={modal1}
          backdrop="static"
          toggle={this.toggle1}
          style={{ maxWidth: 1000, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Edit
            </h4>
          </div>
          <div className="modal__body" style={{ marginTop: 10, padding: 10 }}>

              <div style={{width: '100%',float: 'left'}}>
              <div
                className="form__form-group "
                style={{ marginBottom: "0px", width: '16%', float: 'left'}}
              >
                
                <div
                  className="form__form-group-field"
                  
                >
               <ButtonToolbar className="modal__footer">
                <Button
                  style={{
                    backgroundColor: "#24d6a3",
                    color: "#fff",
                    marginLeft: 32,
                  }}
                  className="modal_ok"
                  disabled={this.state.disable_submit_button}
                  onClick={this.addRow}
                >
                  {this.state.ShowConfirmLoader && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  Add Row
                </Button>
                </ButtonToolbar>
                </div>
              </div> 
              <div
                className="form__form-group "
                style={{ marginBottom: "0px", width: '21%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
               <ButtonToolbar className="modal__footer">
                <Button
                  style={{
                    backgroundColor: "#24d6a3",
                    color: "#fff",
                    marginLeft: 32,
                  }}
                  className="modal_ok"
                  disabled={this.state.disable_submit_button}
                  onClick={this.removeRow}
                >
                  {this.state.ShowConfirmLoader && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  Remove Row
                </Button>
                </ButtonToolbar>
                </div>
              </div> 



              <div
                className="form__form-group "
                style={{ marginBottom: "0px", width: '32%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >

                <ButtonToolbar className="modal__footer">
                <Button
                  style={{
                    backgroundColor: "#24d6a3",
                    color: "#fff",
                    marginLeft: 12,
                  }}
                  className="modal_ok"
                  disabled={this.state.disable_submit_button}
                  onClick={this.editASN}
                >
                  {this.state.ShowConfirmLoader && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  Confirm
                </Button>
              </ButtonToolbar>
                  
                   
                </div>
              </div> 

              </div>


            <div style={{width: '100%', float: 'left', marginTop: 30, marginBottom: 20}}>
            <div
                className="form__form-group "
                style={{ marginBottom: "0px",width: '34%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label style={{marginTop: 5,width: '40%', float: 'left'}} for="item_code">Invoice Qty</label>
                   <div style={{width: '60%', float: 'left'}}>
                   <input disabled type = "text" value={this.state.auto_invoice} className="form-control group_text_2" placeholder= "Invoice Qty" onChange={this.InvoiceChange}/>
                  </div>
                </div>
              </div>

              <div
                className="form__form-group "
                style={{ marginBottom: "0px", width: '34%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label style={{marginTop: 5,width: '30%', float: 'left'}} for="item_code">Total in Eaches</label>
                   <div style={{width: '60%', float: 'left'}}>
                   <input disabled type = "text" value={this.state.total_value} className="form-control group_text_2" placeholder= "Total " onChange={this.Change}/>
                  </div>
                </div>
              </div>

               <div
                className="form__form-group "
                style={{ marginBottom: "0px", width: '32%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  
                </div>
              </div> 
              </div> 

              <hr style={{marginTop: 120}}/> 

               {array_Data.map((item, index) => (
                <div style={{marginTop: 10}}>
                 <div
                className="form__form-group "
                style={{ marginBottom: "0px", width: '20%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                > 
                { index > 0 &&
                    <input type='checkbox' checked={item.isChecked} onChange={() => this.checkedSingle2(index,item.isChecked)} />
                }
                {
                  index === 0 && 
                  <span style={{marginLeft:12}}></span>
                }
                  
                  <label style={{marginTop: 5,width: '60%', float: 'left', display: 'none'}} for="item_code">Outer Qty</label>
                   <div style={{width: '30%', float: 'left', display: 'none'}}>
                   <input type = "text" style={{width: 80}}  className="form-control group_text_8" placeholder= "" onChange={(evt) => this.OuterChange(evt,item.id, index)} />
                  </div>
                </div>
              </div>  


               <div
                className="form__form-group "
                style={{ marginBottom: "0px", width: '20%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                 <label style={{marginTop: 5,width: '60%', float: 'left'}} for="item_code">Inner Qty</label>
                   <div style={{width: '30%', float: 'left'}}>
                   <input type = "text" style={{width: 80}}  className="form-control group_text_8" placeholder= ""  onChange={(evt) => this.InnerChange(evt,item.id, index)} />
                  </div>
                </div>
              </div>

               <div
                className="form__form-group "
                style={{ marginBottom: "0px", width: '20%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label style={{marginTop: 5,width: '60%', float: 'left'}} for="item_code">Each Qty</label>
                   <div style={{width: '30%', float: 'left'}}>
                   <input  type = "text" style={{width: 80}}  className="form-control group_text_8" placeholder= ""  onChange={(evt) => this.EachChange(evt,item.id, index)} />
                  </div>
                </div>
              </div>  

               <div
                className="form__form-group "
                style={{ marginBottom: "0px", width: '20%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                 <label style={{marginTop: 5,width: '60%', float: 'left'}} for="item_code">Batch</label>
                   <div style={{width: '30%', float: 'left'}}>
                   <input type = "text" defaultValue={item.batch} style={{width: 80}}  className="form-control group_text_8" placeholder= "-" onChange={(evt) => this.BatchChange(evt,item.id, index)}  />
                  </div>
                </div>
              </div>  

               <div
                className="form__form-group "
                style={{ marginBottom: "0px", width: '20%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label style={{marginTop: 5,width: '60%', float: 'left'}} for="item_code">PKD</label>
                   <div style={{width: '30%', float: 'left'}}>
                   <input  type = "text" value={item.pkd} style={{width: 80}}  className="form-control group_text_8" placeholder= ""  onChange={(evt) => this.PKDChange(evt,item.id, index)} />
                  </div>
                </div>
              </div>    

              </div>
                ))}


           
     

            <div style={{ width: "100%", float: "left", marginTop: 20 }}>
              <ButtonToolbar className="modal__footer">
                <button
                  className="modal_cancel"
                  onClick={this.toggleNPICancel}
                >
                  Cancel
                </button>

              </ButtonToolbar>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={modal2}
          toggle={this.toggle2}

          style={{ maxWidth: 1000, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Review Data
            </h4>
          </div>
          <div className="modal__body" style={{ marginTop: 10, padding: 16 }}>
            <div
              className="req_type"
              style={{
                width: "100%",
                float: "left",
                paddingBottom: 12,
                borderBottomWidth: 1,
                borderColor: "#ccc",
              }}
            >
              

              
              

              
            </div>

            

            {this.state.apply1 && (
              <div style={{ width: "100%", float: "left" }}>
                <span style={{color: 'red'}}>{this.state.reviewErr}</span>
                <table
                  className="table table-bordered table-hover"
                  id="tab_logic"
                >
                  <thead style={{ textAlign: "left" }}>
                    <tr>

                      <th>Van Name</th>
                      <th>Total Bill</th>
                      <th>Total Values </th>
                      <th>Total Weight </th>
                      <th>Location </th>
                      <th>Zone </th>
                      
                    </tr>
                  </thead>
                  <tbody>
                      {this.state.reviewData.length > 0 &&
                        this.state.reviewData.map((item, index) => (
                          <tr>
                            <td>{item.van_name}</td>
                            <td>{item.total_bills}</td>
                            <td>{item.total_values}</td>
                            <td>{item.total_weight}</td>
                            <td>{item.locations}</td>
                           
                            <td>
                              <select
                                className="form-control"
                                value={this.state.store_id}
                                style={{ fontSize: 13 }}
                                
                                onChange={(evt) =>
                                  this.ChangeZone(evt, index)
                                }
                              >
                                <option value="">Select zone</option>
                                {
                                  this.state.zoneData.length > 0 &&
                                  this.state.zoneData.map((zoneData) => {
                                    return (
                                      <option value={zoneData.id}> {zoneData.name} - {zoneData.type}</option>
                                    );
                                  })}
                              </select>
                            </td>
                            </tr>
                        ))}

                    
                  </tbody>
                </table>

               
              </div>
            )}

            <div style={{ width: "100%", float: "left", marginTop: 12 }}>
              <ButtonToolbar className="modal__footer">
                <button
                  className="modal_cancel"
                  onClick={this.toggle2}
                >
                  Cancel
                </button>

                <Button
                  style={{
                    backgroundColor: "#24d6a3",
                    color: "#fff",
                    marginLeft: 12,
                  }}
                  className="modal_ok"
                  disabled={this.state.disable_submit_button}
                  onClick={this.onConfirmProduct}
                >
                  {this.state.ShowEditLoader && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  Create
                </Button>
              </ButtonToolbar>
            </div>
          </div>
        </Modal>


        <Modal isOpen={SuccessMessageModal1} toggle={this.SuccessMessageToggle1}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.SuccessMessageToggle1}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red", marginBottom: 6 }}
            />
            <h5>{this.state.respMsg} </h5>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.onClickMissingProduct}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={SuccessConfirmmodal} backdrop="static" toggle={this.SuccessConfirmtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.SuccessConfirmtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr  modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h5 style={{width: '70%'}}>Enter Van Name: </h5>
            

           
            
            <div style={{marginTop: 6, width: '86%'}}>
                <input type = "text"  className="form-control group_text1" placeholder= "Enter Van Name" onChange={this.handleChangeVan1} />
               
            </div>
            
          </div>
          <ButtonToolbar className="modal__footer">
            <button
                  style={{ marginRight: 8 }}
                  className="modal_cancel"
                  onClick={this.SuccessConfirmtoggle}
                >
                  Cancel
                </button>

            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.AssignData}
              disabled={this.state.assignDisabled}
            >
            {this.state.assignLoader && (
              <i
                className="fa fa-refresh fa-spin"
                style={{ marginRight: "5px" }}
              />
            )}
              Assign
            </Button>
          </ButtonToolbar>
        </Modal>

         <Modal isOpen={SuccessConfirmmodal1} backdrop="static" toggle={this.SuccessConfirmtoggle1}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.SuccessConfirmtoggle1}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr  modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h5 style={{width: '70%'}}>Enter ASN: </h5>
            

           
            
            <div style={{marginTop: 6, width: '86%'}}>
                <input type = "text" className="form-control group_text1" placeholder= "Enter ASN" onChange={this.handleChangeASN}/>
                <span
                    className="pull-right"
                    onClick={() => exportToCSV(this.state.posts, "AreaMaster", Heading)}
                    style={{
                      fontSize: "17px",
                      paddingRight: "0px",
                      cursor: "pointer",
                      color: "#919193",
                      paddingTop: "9px",
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                  </span>

            </div>
            
          </div>
          <ButtonToolbar className="modal__footer">
            <button
                  style={{ marginRight: 8 }}
                  className="modal_cancel"
                  onClick={this.SuccessConfirmtoggle1}
                >
                  Cancel
                </button>

            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.AssignData1}
              disabled={this.state.assignDisabled1}
            >
            {this.state.assignLoader1 && (
              <i
                className="fa fa-refresh fa-spin"
                style={{ marginRight: "5px" }}
              />
            )}
              Assign
            </Button>
          </ButtonToolbar>
        </Modal>
        <Modal isOpen={prod_id_state} backdrop="static" toggle = {this.handleProdId}>
          <div className="modal__header">
           
             <div>
             <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.handleProdId}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
            <h3>
              Warning !
            </h3>
            <h4>Same Product Ids lines have been Selected</h4>
            <h4>Do You Want To Proceed ?</h4>
          </div>
          </div>
          <ButtonToolbar className="modal__footer">
            <button
                  style={{ marginRight: 8 }}
                  className="modal_cancel"
                  onClick={this.handleProdId}
                >
                  Cancel
                </button>

            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.AssignData1}
              disabled={this.state.assignDisabled1}
            >
            {this.state.assignLoader1 && (
              <i
                className="fa fa-refresh fa-spin"
                style={{ marginRight: "5px" }}
              />
            )}
              Confirm
            </Button>
          </ButtonToolbar>
        </Modal>
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
